import React, { useState } from "react";
import OrganizerFundsTab from "./OrganizerFundsTab";
import RegistrationsTab from "./RegistrationsTab";
import RegistrationPackagesTab from "./RegistrationPackagesTab";
import "./DetailsTabs.css";

const TABS = {
  ORGANIZER_FUNDS: "organizer-funds",
  REGISTRATIONS: "registrations",
  PACKAGES: "packages",
};

const DetailsTabs = ({ data }) => {
  const [activeTab, setActiveTab] = useState(TABS.ORGANIZER_FUNDS);

  const tabs = [
    {
      id: TABS.ORGANIZER_FUNDS,
      label: `Organizer Funds Request${Array.isArray(data?.organizerFundsRequests) ? ` (${data.organizerFundsRequests.length})` : ""}`,
      component: OrganizerFundsTab,
    },
    {
      id: TABS.REGISTRATIONS,
      label: `Registrations${Array.isArray(data?.registrations) ? ` (${data.registrations.length})` : ""}`,
      component: RegistrationsTab,
    },
    {
      id: TABS.PACKAGES,
      label: `Registration Packages${Array.isArray(data?.registrationPackages) ? ` (${data.registrationPackages.length})` : ""}`,
      component: RegistrationPackagesTab,
    },
  ];

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="details-tabs">
      <div className="details-tabs__header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`details-tabs__tab ${
              activeTab === tab.id ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="details-tabs__content">
        {ActiveComponent && <ActiveComponent data={data} />}
      </div>
    </div>
  );
};

export default DetailsTabs;
